export default __webpack_public_path__ + "static/Lato-Normal-012192c7b29d9aac95ffae56dcff0bc0.woff2";